<template>
  <div
    class="template-editor"
  >
    <templates-menu>
      <div
        class="d-flex"
      >
        <!-- <b-col cols="2">
          <base-button
            v-if="loaded_template"
            @click="deleteTemplate()"
            inverse
          >
            Delete Template
          </base-button>
        </b-col> -->
        <!--         <b-col cols="2">
          <b-button @click="state='creating'">
            New Template
          </b-button>
        </b-col> -->

        <base-button
          inverse
          :disabled="selectedInstitution === null || loaded_template === null"
          @click="sendPreviewToLitmus"
        >
          Send to Litmus
        </base-button>

        <base-button
          :disabled="!canSave"
          @click="onSaveChanges"
        >
          Save Changes
        </base-button>
      </div>
    </templates-menu>
    <div class="template-editor__tools">
      <div class="template-editor__tools__left">
        <b-form-select
          v-model="selectedInstitutionId"
          size="sm"
          :options="orderedInstitutions"
        >
          <template #first>
            <b-form-select-option
              :value="null"
              disabled
            >
              -- Institution --
            </b-form-select-option>
          </template>
        </b-form-select>

        <b-form-select
          v-model="selected"
          size="sm"
          :options="options"
        >
          <template #first>
            <b-form-select-option
              :value="null"
              disabled
            >
              -- Template --
            </b-form-select-option>
          </template>
        </b-form-select>

        <b-form-select
          v-model="selectedRevision"
          :options="revisions"
          variant="dark"
          size="sm"
        >
          <template #first>
            <b-form-select-option
              :value="null"
              disabled
            >
              -- Revision --
            </b-form-select-option>
          </template>
        </b-form-select>
      </div>

      <div class="template-editor__tools__right">
        <!-- <div class="text-center mt-n5 mb-n2">
          <base-button
            class="mb-2"
            @click="previewZoom = 100"
          >
            100%
          </base-button>
          <div><label for="range-1">{{ previewZoom }}%</label></div>
        </div>
        <b-form-input
          id="range-1"
          v-model="previewZoom"
          type="range"
          :min="20"
          :max="180"
          placeholder="Zoom"
          show-value
        /> -->

        <b-button
          v-b-toggle.profile-sidebar
          :disabled="Object.keys(theme).length === 0"
          size="sm"
        >
          <font-awesome-icon :icon="['fas', 'cog']" />
        </b-button>

        <b-form-select
          v-model="selectedPreviewType"
          size="sm"
          class="ml-auto"
          :options="previewTypeOptions"
        />

        <b-form-select
          v-model="previewZoom"
          size="sm"
          class="ml-auto"
        >
          <b-form-select-option
            v-for="n in [25, 50, 75, 100]"
            :key="n"
            :value="n"
          >
            {{ n }}%
          </b-form-select-option>
        </b-form-select>

        <!-- <b-tabs
          v-model="selectedPreviewType"
          fill
        >
          <b-tab
            v-for="(item, index) in previewTypeOptions"
            :key="`preview_options_${index}`"
            :disabled="!selectedTemplate"
            :title="item.text"
          />
        </b-tabs> -->
      </div>
      <!-- <b-col cols="2">
          <b-button
            v-if="state=='creating'"
            @click="create_template"
          >
            Create
          </b-button>
          <b-button
            v-if="state=='creating'"
            @click="state = null"
          >
            Cancel
          </b-button>
        </b-col> -->
      <!-- <b-col> -->
      <!-- <a
            v-if="loaded_template"
            target="_blank"
            href="#"
          >Open in new window</a> -->
      <!--  <template #first>
            <b-form-select-option
              :value="null"
              disabled
            >
              -- Preview Choice --
            </b-form-select-option>
          </template>
          </b-form-select> -->
      <!-- </b-col> -->
      <b-row class="d-none">
        <b-col>
          <b-progress
            v-show="loading"
            :value="100"
            :max="100"
            animated
            variant="secondary"
          />
          <!-- <base-progress-bar
          v-if="saveTimeout"
          :key="timerStart"
          :max="saveDelay"
          :current="Date.now() - timerStart"
        /> -->
        </b-col>
      </b-row>
    </div>
    <div>
      <b-sidebar
        id="profile-sidebar"
        bg-variant="dark"
        text-variant="light"
        shadow
        style="position: absolute; z-index: 10"
      >
        <div class="p-4">
          <h4>Theme overrides</h4>
          <div class="profile-settings--grid">
            <div
              v-for="key in Object.keys(theme).filter(k => k !== 'id')"
              :key="key"
            >
              <div class="text-capitalize">
                {{ key.replaceAll('_', ' ') }}
              </div>
              <input
                v-model="theme[key]"
                type="text"
              >
            </div>
          </div>
          <hr>
          <h4>Profile</h4>
          <div class="profile-settings--grid">
            <div
              v-for="key in Object.keys(profileSettings)"
              :key="key"
            >
              <div class="text-capitalize d-flex align-items-center">
                <span
                  v-if="defaultProfileSettings()[key] !== profileSettings[key]"
                  class="redo d-flex align-items-center"
                >
                  <base-icon
                    icon="redo"
                    class="redo__icon mr-2"
                    @click="onResetDefaultProfileSetting(key)"
                  />
                  <span class="redo__tooltip">Reset to <pre>{{ getDefault(key) }}</pre></span>
                </span>
                {{ key.replaceAll('_', ' ') }}
              </div>
              <input
                v-model="profileSettings[key]"
                :type="{string: 'text', boolean: 'checkbox'}[typeof(profileSettings[key])]"
              >
            </div>
          </div>
          <b-button class="w-100 mt-4 d-none">
            Save
          </b-button>
        </div>
      </b-sidebar>
    </div>
    <div
      style="height: calc(100vh - 87px - 30px)"
    >
      <div
        class="d-flex text-center h-100"
      >
        <div class="h-100 template-editor__code">
          <base-textarea
            v-model="textAreaContent"
            code="text/javascript"
            :light="!darkTheme"
            :disabled="isEditable"
          />
        </div>
        <div class="h-100 template-editor__preview">
          <!-- <b-form-select
            v-model="selectedPreviewType"
            :options="previewTypeOptions"
          > -->
          <iframe
            :srcdoc="content"
            width="100%"
            height="100%"
            frameborder="0"
          />
          <!-- <edit-preview
            v-if="textAreaContent.length && selectedInstitutionId"
            ref="editPreview"
            :content="content"
            :scale="previewZoom/100"
            scrolling="yes"
            contain
          /> -->
        </div>
      </div>
    </div>
    <div class="template-editor__footer">
      <base-button
        small
        :inverse="darkTheme"
        style="opacity: 0.5"
        @click="darkTheme = !darkTheme"
      >
        {{ !darkTheme ? 'Light' : 'Dark' }} theme
      </base-button>

      <base-button
        class="ml-auto"
        style="opacity: 0.5"
        inverse
        small
        :disabled="selectedInstitution === null || loaded_template === null"
        @click="onResetDefault"
      >
        Factory reset
      </base-button>
    </div>
    <div class="d-none">
      {{ message }}
    </div>
  </div>
</template>

<script>

import api from '@/_api';
import { institutionService } from '@/_services';
import { EventBus } from '@/event-bus';
import _ from 'lodash';
import TemplatesMenu from './TemplatesMenu';

const REFRESH_TIMEOUT = 1000; // ms. Wait this time before updating preview template

export default {
  name: 'TemplateEditor',
  components: { TemplatesMenu },
  data() {
    return {
      create_filename: null,
      loaded_template: null,
      state: null,
      // Current template selected on dropdown. Stores dropdown 'value'.
      selected: null,
      selectedRevision: null,
      textAreaContent: '',
      message: '',
      options: [],
      revisions: [],

      institutions: [],
      selectedInstitutionId: null,

      saveTimeout: null,
      timerStart: 0,
      darkTheme: true,

      selectedPreviewType: 0,
      previewTypeOptions: [
        {
          text: 'Email',
          value: 0,
        },
        {
          text: 'Print',
          value: 1,
        },
      ],
      defaultTemplates: [],
      loading: false,
      content: '',
      previewZoom: 100,
      theme: {},
      profileSettings: this.defaultProfileSettings(),
    };
  },
  computed: {
    orderedInstitutions() {
      return _.sortBy(this.institutions, ['text']);
    },
    previewUrl() {
      // eslint-disable-next-line
      if (this.selectedPreviewType < 0) this.selectedPreviewType = 0;
      return ['preview_template', 'preview_print_template'][this.selectedPreviewType];
    },
    selectedInstitution() {
      // Selected institution object
      return this.institutions?.find((i) => i.value === this.selectedInstitutionId) ?? null;
    },
    selectedTemplate() {
      return this.options.find((option) => option.value === this.selected) ?? null;
    },
    isEditable() {
      return !this.loaded_template || !this.loaded_template.id || this.isCustom;
    },
    isCustom() {
      // If selected template is custom. False if it's using default
      return this.selectedTemplate?.versions?.length > 0 ?? false;
    },
    canSave() {
      return this.isCustom;
    },
  },
  watch: {
    selectedInstitutionId(newVal) {
      this.selected = null;
      this.content = '';
      this.loadTemplates(newVal);
      this.fetchInstitutionTheme(newVal);
    },
    selected(templateName) {
      // Template was selected
      this.onTemplateSelected(templateName);
      this.revisions = this.selectedTemplate?.versions.map((e, i) => ({
        ...e,
        text: e.custom ? 'Custom' : this.$moment(e.created).format('DD/MM/YY HH:mm'),
        value: i,
      })) ?? [];
      if (this.revisions.length !== 0) {
        this.selectedRevision = 0;
      }
    },
    selectedRevision(revisionIndex) {
      this.fetchTemplate(this.selectedTemplate.versions[revisionIndex]);
    },
    selectedPreviewType() {
      this.previewTemplate();
    },
    textAreaContent() {
      this.debouncedPreviewTemplate();
    },
    message(value) {
      if (value.length > 0) {
        setTimeout(() => { this.message = ''; }, 1000);
      }
    },
    selectedTemplate(newVal) {
      if (newVal === null) this.textAreaContent = newVal?.content ?? '';
    },
    profileSettings: {
      deep: true,
      handler() {
        this.debouncedPreviewTemplate();
      },
    },
    theme: {
      deep: true,
      handler() {
        this.debouncedPreviewTemplate();
      },
    },
  },
  mounted() {
    this.loading = true;
    this.fetchInstitutions().then(() => this.fetchDefaultTemplates()).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    defaultProfileSettings() {
      return {
        first_name: 'Skilled',
        last_name: 'Stylist',
        profile_pic: null,
        phone_number: '',
        instagram: '',
        email: 'test@helloseer.com',
        imessage: false,
        whatsapp: false,
      };
    },
    fetchInstitutions(url = '/institution/') {
      console.log('Fetching institutions...');
      return api.get(url).then((response) => {
        // TODO: Check if backend paginates
        this.institutions = [
          ...this.institutions,
          ...response.data.results
            .map((v) => ({ value: v.pk, text: `${v.name} (pk ${v.pk})`, theme: v.theme }))];
        // Recursives pages
        if (response.data.next) {
          this.fetchInstitutions(response.data.next);
        }
      });
    },
    /** Fetches currently supported 'default' templates */
    // TODO: Maybe backend could serialize default templates on institution template retrieval instead of a separate endpoint?
    fetchDefaultTemplates() {
      console.log('Fetching default templates...');
      return api.get('/templates/defaults').then((response) => {
        this.defaultTemplates = response.data;
      });
    },
    onTemplateSelected(templateName) {
      // If template is not implemented, warn before creating
      console.log('Template index selected: ', templateName);
      if (this.selectedTemplate?.versions?.length) {
        // Is implemented. Fetch latest
        this.fetchTemplate(this.selectedTemplate.versions[0]);
        return;
      }

      // none selected
      if (templateName === null) return;

      // Non-implemented default template was selected.
      // Load contents to textarea and refresh
      const template = this.defaultTemplates.find((t) => t.name === templateName);
      this.textAreaContent = template.content;

      // Offer to create new from default
      EventBus.$emit('confirm', {
        message: 'Create a new template from default?',
        positiveText: 'Create',
        showCancel: true,
        callback: (confirm) => {
          if (confirm) {
            this.createTemplate(template.name, template.content);
          }
        },
      });
    },
    onResetDefault() {
      if (!this.selectedInstitution || !this.selectedTemplate) return;
      // Paste default contents on this template
      const vm = this;
      EventBus.$emit('confirm', {
        message: 'Replace your changes with default template contents? You can revert this change later.',
        positiveText: 'Replace',
        showCancel: true,
        callback: (confirm) => {
          if (confirm) {
            vm.textAreaContent = vm.defaultTemplates.find((t) => t.name === vm.selectedTemplate.name).content;
          }
        },
      });
    },
    /** Retrieves selected institution templates. Groups them by name. Takes care of special 'default' templates. */
    loadTemplates() {
      if (!this.selectedInstitution) {
        return new Promise((resolve, reject) => { reject(new Error('Cannot load template if for undefined institution')); });
      }
      console.log('loading templates...');
      const institutionId = this.selectedInstitution.value;

      const templateMap = new Map();
      return institutionService.getTemplates(institutionId).then((response) => {
        [...this.defaultTemplates, ...response.data].forEach((template, index) => {
          if (!templateMap.has(template.name)) templateMap.set(template.name, []);
          if (template.id) { // defaults have no pk
            templateMap.get(template.name).push(template);
          }
        });
        this.options = [];
        templateMap.forEach((value, key, map) => {
          this.options.push({
            value: key,
            text: `${key} ${value.length ? `(${value.length} versions)` : '(using default)'}`,
            name: key,
            disabled: this.selectedInstitution === null,
            // Sort by newest implementation
            versions: value.sort((t1, t2) => this.$moment(t2.modified ?? t2.created)
              .diff(this.$moment(t1.modified ?? t1.created))),
          });
        });
        console.log('Loaded templates');
        this.message = 'Got Templates';
      });
    },
    fetchTemplate(template) {
      this.loading = true;
      if (template.custom) {
        // Here, template.id is the id of the custom template's PROFILE (owner)
        api.get(`/profile/${template.id}/`).then((response) => {
          this.loaded_template = template;
          this.textAreaContent = response.data.custom_template;
        }).finally(() => {
          this.loading = false;
        });
      } else {
        // TODO: why get them if we have them alredy?
        api.get(`/templates/${template.id}/`).then((value) => {
          this.loaded_template = value.data;
          this.textAreaContent = this.loaded_template.content;
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    fetchInstitutionTheme() {
      if (!this.selectedInstitution) return;
      api.get(this.selectedInstitution.theme).then((response) => {
        this.theme = response.data;
      });
    },
    onSaveChanges() {
      // Warn new template creation
      const vm = this;
      const message = vm.selectedTemplate.versions[0].custom ? `Edit this custom template of ${vm.selectedTemplate.versions[0].name} from your changes? You cannot undo this` : 'Create new template version from your changes? You can go back if needed ;)';
      EventBus.$emit('confirm', {
        message,
        positiveText: vm.selectedTemplate.versions[0].custom ? 'Save' : 'Create',
        showCancel: true,
        callback: (confirm) => {
          if (confirm) {
            if (vm.selectedTemplate.versions[0].custom) {
              vm.createCustomTemplate(vm.selectedTemplate.versions[0].id, vm.textAreaContent);
            } else {
              vm.createTemplate(vm.selectedTemplate.name, vm.textAreaContent);
            }
          }
        },
      });
    },
    sendPreviewToLitmus() {
      this.loading = true;
      api.post(`/${'send_preview_to_litmus'}/${this.selectedInstitutionId}/`, {
        template_string: this.textAreaContent,
      }).then(() => {
        EventBus.$emit('confirm', {
          message: 'E-mail to litmus sent successfully',
          showCancel: false,
          positiveText: 'OK',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    debouncedPreviewTemplate() {
      // Set timer
      if (this.saveTimeout !== null) window.clearTimeout(this.saveTimeout);
      this.timerStart = Date.now();
      this.saveTimeout = window.setTimeout(this.previewTemplate, REFRESH_TIMEOUT);
    },
    previewTemplate() {
      if (!this.selectedTemplate) {
        console.log('Cannot preview undefined template');
        return;
      }
      console.log('Previewing changes...');
      this.loading = true;

      api.post(`/${this.previewUrl}/${this.selectedInstitutionId}/`, {
        template_string: this.textAreaContent,
        template_name: this.selectedTemplate.name,
        profile: this.profileSettings,
        theme: this.theme,
      }).then((response) => {
        this.content = response.data;
        this.$nextTick().then(() => {
          // eslint-disable-next-line
          // this.$refs.editPreview?.refresh();
        });
      }).catch((error) => {
        if (error.response) {
          this.content = error.response.data;
          if (error.response.status >= 500) {
            console.log("The server didn't like this");
          } else if (error.response.status >= 400) {
            console.log('You did something wrong');
          }
        } else {
          console.log("The request didn't even leave this computer!", error);
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    /** Create template from current contents. Creates new version for template, does not replace contents. */
    createTemplate(name, content) {
      this.loading = true;
      api.post('/templates/', {
        name,
        content,
        institution: this.selectedInstitution.value,
      }).then((response) => {
        // Refresh institution templates
        console.log('New template created');
        this.loadTemplates().then(() => {
          // Select new template and load its contents
          this.revisions = this.selectedTemplate?.versions.map((e, i) => ({ ...e, text: this.$moment(e.created).format('DD/MM/YY HH:mm'), value: i })) ?? [];
          this.selectedRevision = 0;
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    createCustomTemplate(profileId, content) {
      this.loading = true;
      api.patch(`/profile/${profileId}/`, {
        custom_template: content,
      }).then((response) => {
        console.log('Custom template edited');
      }).finally(() => {
        this.loading = false;
      });
    },
    getDefault(key) {
      const result = this.defaultProfileSettings()[key] ?? 'null';
      return result.length === 0 ? '<empty>' : result;
    },
    onResetDefaultProfileSetting(key) {
      this.profileSettings[key] = this.defaultProfileSettings()[key];
    },
  },
};
</script>
<style lang="scss" scoped>
.template-editor{
  background-color: $black;
}
.template-editor__footer{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30px;
  box-shadow: 0 0 5px rgba(black, 0.2);
  background-color: $black;
}
.template-editor__code{
  border-right: solid 10px rgba(black, 0.3);
  padding: 0;
  width: 50%;
}
.template-editor__preview{
  padding: 0;
  width: 50%;
}
.template-editor__tools{
  padding: 0.5rem;
  display: flex;
  border-bottom: solid 1px rgba(black, 0.2);
}
.template-editor__tools__left{
  width: 50%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.template-editor__tools__right{
  margin-left: auto;
  display: grid;
  grid-template-columns: 50px repeat(2, 100px);
  gap: 10px;
}
::v-deep .nav-tabs {
  border-bottom: none;
  box-shadow: 0px 12px 10px -17px #00000088;
}
.custom-select{
  color: #999;
  border: 1px solid #555;
  background-color: $black;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' \
width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23999999' d='M2 0L0 2h4zm0 5L0 \
3h4z'/%3e%3c/svg%3e") !important;
}
.profile-settings--grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  column-gap: 10px;
  row-gap: 5px;
}
.redo {
  position: relative;
  display:inline-block;
  cursor: pointer;

  &__icon {
    filter: invert(1);
    transition: transform .2s ease-in-out;
    &:hover {
      transform: rotate(180deg);
    }
  }

  &__tooltip {
    text-transform: none;
    visibility: hidden;
    width: 120px;
    left: 20px;
    text-align: center;
    background-color: white;
    color: black;
    position: absolute;
    border-radius: 4px;
    z-index: 1;
  }

  &:hover &__tooltip {
    visibility: visible;
  }
}
</style>
